import { useRef, useEffect, FC } from 'react';

type Props = {
  uri: string;
  isActive: boolean;
};

export const VideoSlide: FC<Props> = ({ uri, isActive }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const stop = () => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;
      video.pause();
      video.currentTime = 0; // Reset video to the start
    }
  };

  const play = () => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;

      // Simple check for whether the video is currently playing
      const isPlaying =
        !video.paused &&
        !video.ended &&
        video.readyState > video.HAVE_CURRENT_DATA;

      if (!isPlaying) {
        video.play().catch((error) => {
          console.error('Error while trying to play video:', error);
        });
      }
    }
  };

  useEffect(() => {
    if (isActive) {
      play();
    } else {
      stop();
    }

    return () => stop();
  }, [isActive]);

  return (
    <video
      disablePictureInPicture
      ref={videoRef}
      style={{
        width: '100%',
        backgroundColor: 'black',
        objectFit: 'contain',
        objectPosition: 'center',
      }}
      onError={(e) => console.error('Video playback error:', e)}
    >
      <source src={uri} type="video/mp4" />
      {/* Add fallback content for browsers that don't support video */}
      Your browser does not support the video tag.
    </video>
  );
};
